export const parseFilename = (url) => new URL(url).pathname.split("/").pop();
